class PluginHub {
  constructor({ options, appInfo, baseHelpers }) {
    this.options = options
    this.appInfo = appInfo
    this.baseHelpers = baseHelpers
    this.plugins = {}
    this.ready = false
  }

  start(connectFactory) {
    if (!this.ready) {
      connectFactory(this)

      Object.keys(this.plugins).forEach(pluginName => {
        this.plugins[pluginName].start()
      })
      this.ready = true
    } else {
      throw new Error(`[PluginHub] start fn has been called more than once`)
    }
  }

  checkReady() {
    if (!this.ready) {
      throw new Error('[PluginHub] is not yet started')
    }
  }

  /* ------------------------------------------- */

  getAppInfo() {
    return this.appInfo
  }

  getShopifyClient() {
    return this.baseHelpers.$shopify
  }

  getHttpClient() {
    return this.baseHelpers.$http
  }

  getLogger() {
    return this.baseHelpers.$logger
  }

  getDetector() {
    return this.baseHelpers.$detector
  }

  getStorage() {
    return this.baseHelpers.$storage
  }

  getSite() {
    return this.baseHelpers.$site
  }

  /* ------------------------------------------- */

  register(name, Factory, options) {
    if (this.plugins[name]) {
      throw new Error(`[PluginHub] ${name} has already been registry`)
    }

    const $detector = this.getDetector()

    // ignore client only plugin if running on server
    if (!$detector.isServer() || !Factory.isClientOnly) {
      this.plugins[name] = new Factory(options, this)
    }
  }

  /* ------------------------------------------- */

  // ignore client only plugins, for fetchPageData
  //   both on server-side-render and client-side fetchPageData
  getStaticInjectProps(context) {
    this.checkReady()
    return this.getInjectProps(context, { ignoreClientOnlyPlugins: true })
  }

  getInjectProps(context, { ignoreClientOnlyPlugins = false } = {}) {
    this.checkReady()
    const injectPluginProps = {}

    Object.assign(injectPluginProps, this.baseHelpers)

    Object.keys(this.plugins).forEach(key => {
      const plugin = this.plugins[key]
      if (!ignoreClientOnlyPlugins || !plugin.isClientOnly()) {
        Object.assign(injectPluginProps, plugin.getInjectProps(context))
      }

    })

    return injectPluginProps
  }

  getPlugin(key) {
    return this.plugins[key]
  }
}

export default PluginHub